import { Link } from "react-router-dom";
import { allMovies } from "@/lib/movies";

const shortcuts = [
  {
    label: "电影",
    desc: "单部作品完整解析",
    icon: "ri-film-line",
    to: "/category?type=电影",
    count: () => allMovies.filter((movie) => movie.type === "电影").length,
  },
  {
    label: "剧集",
    desc: "分集剧情与线索",
    icon: "ri-live-line",
    to: "/category?type=剧集",
    count: () => allMovies.filter((movie) => movie.type === "剧集").length,
  },
  {
    label: "国产",
    desc: "华语影像作品",
    icon: "ri-home-smile-line",
    to: "/category?region=国产",
    count: () => allMovies.filter((movie) => movie.region === "国产").length,
  },
  {
    label: "港台",
    desc: "港台地区佳作",
    icon: "ri-map-pin-line",
    to: "/category?region=港台",
    count: () => allMovies.filter((movie) => movie.region === "港台").length,
  },
  {
    label: "海外",
    desc: "欧美日韩精选",
    icon: "ri-earth-line",
    to: "/category?region=海外",
    count: () => allMovies.filter((movie) => movie.region === "海外").length,
  },
  {
    label: "悬疑",
    desc: "烧脑与反转",
    icon: "ri-search-eye-line",
    to: "/category?genre=悬疑",
    count: () => allMovies.filter((movie) => movie.genres.includes("悬疑")).length,
  },
];

export default function CategoryShortcuts() {
  return (
    <section className="relative -mt-6 md:-mt-8 z-20">
      <div className="max-w-shell mx-auto px-4 md:px-8">
        <div className="rounded-lg border border-background-200/80 bg-background-100/95 backdrop-blur-sm p-2 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-1.5">
          {shortcuts.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              className="group flex items-center gap-3 rounded-md px-3 py-3 md:px-4 md:py-4 hover:bg-background-200/60 transition-colors cursor-pointer"
            >
              <span className="w-9 h-9 md:w-10 md:h-10 shrink-0 rounded-md bg-background-200/80 text-primary-600 group-hover:bg-primary-500 group-hover:text-foreground-50 flex items-center justify-center transition-colors">
                <i className={`${item.icon} text-base md:text-lg`}></i>
              </span>
              <span className="min-w-0">
                <span className="flex items-baseline gap-1.5">
                  <span className="text-sm font-medium text-foreground-100">{item.label}</span>
                  <span className="font-label text-[11px] text-foreground-600">
                    {item.count()}
                  </span>
                </span>
                <span className="block text-[11px] text-foreground-600 truncate">{item.desc}</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}